import { OnInit, ElementRef, EventEmitter } from '@angular/core';
import { TimelineService } from '../timeline/timeline.service';
import { Project, Occurence } from '../interfaces/interfaces';
var TimelineOccurenceComponent = /** @class */ (function () {
    function TimelineOccurenceComponent(timelineService, elementRef) {
        this.timelineService = timelineService;
        this.elementRef = elementRef;
        this.select = new EventEmitter();
    }
    TimelineOccurenceComponent.prototype.ngOnInit = function () {
    };
    TimelineOccurenceComponent.prototype.click = function (occurence) {
        this.select.emit(occurence);
    };
    return TimelineOccurenceComponent;
}());
export { TimelineOccurenceComponent };
//# sourceMappingURL=timeline-occurence.component.js.map